export enum STAGE {
  MAIN_VIEW,
  CREATE_TEAM_VIEW,
  ASSIGN_TEAM_VIEW,
}

export const STAGE_TITLE = {
  [STAGE.MAIN_VIEW]: 'Create/Assign to Work Team(s)',
  [STAGE.CREATE_TEAM_VIEW]: 'Create Subteam',
  [STAGE.ASSIGN_TEAM_VIEW]: 'Assign Current Project to Team',
};

export const ALERT_CONTENT = {
  assignSuccess: { severity: 'success', content: 'Successfully assigned!' },
  addTeamSuccess: { severity: 'success', content: 'Successfully created!' },
  error: { severity: 'error', content: 'something went wrong, please try again.' },
};

export const DEFAULT_TEAM = {
  id: '617709575ddbae6a1edab50d', // set default team to be root team
  name: 'Root Team',
};
